import { State } from './types';

const initialState: State = {
	byName: {}
};

export default initialState;
